export const isValidUKPhoneNumber = (phone: string) => {
  return phone.length === 13 && /^(\+447|\+4420|\+441|\+442)/.test(phone)
}
